import { apiClient } from './client';

// Types for Dashboard API responses
export interface KPIMetrics {
  pending_amount: number;
  recovery_rate_30: number;
  recovery_rate_60: number;
  recovery_rate_90: number;
  dias_promedio_cobro: number; // Days Sales Outstanding en español
  overdue_invoices_by_period: {
    '0-30': number;
    '31-60': number;
    '61-90': number;
    '90+': number;
  };
}

export interface KPIResponse {
  current: KPIMetrics;
  previous: Partial<KPIMetrics>; // Puede que no tenga todos los campos
}

export interface ActivationFunnel {
  invoices_loaded: number;
  reminders_sent: number;
  emails_opened: number;
  payments_received: number;
}

export interface FilterParams {
  start_date?: string;
  end_date?: string;
}

export interface DrillDownFilters {
  status?: string;
  days_overdue_min?: number;
  days_overdue_max?: number;
  amount_min?: number;
  amount_max?: number;
  debtor_id?: number;
}

// API functions
export const getDashboardKPIs = async (filters?: FilterParams) => {
  try {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);

    const queryString = params.toString();
    const endpoint = `/billing/invoices/dashboard/kpis/${queryString ? `?${queryString}` : ''}`;
    
    console.log('🌐 KPIs API request:', {
      endpoint,
      filters,
      queryString
    });
    
    const response = await apiClient.get(endpoint);
    
    console.log('📥 KPIs API response:', response);
    
    return {
      success: true,
      data: response as KPIResponse,
    };
  } catch (error: any) {
    console.error('💥 KPIs API error:', {
      error,
      response: error.response?.data,
      status: error.response?.status
    });
    
    return {
      success: false,
      error: error.response?.data?.detail || 'Error al obtener métricas KPI',
    };
  }
};

export const getActivationFunnel = async (filters?: FilterParams) => {
  try {
    const params = new URLSearchParams();
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);

    const queryString = params.toString();
    const endpoint = `/billing/invoices/dashboard/activation-funnel/${queryString ? `?${queryString}` : ''}`;
    
    console.log('🌐 Activation Funnel API request:', {
      endpoint,
      filters,
      queryString
    });
    
    const response = await apiClient.get(endpoint);
    
    console.log('📥 Activation Funnel API response:', response);
    
    return {
      success: true,
      data: response as ActivationFunnel,
    };
  } catch (error: any) {
    console.error('💥 Activation Funnel API error:', {
      error,
      response: error.response?.data,
      status: error.response?.status
    });
    
    return {
      success: false,
      error: error.response?.data?.detail || 'Error al obtener embudo de activación',
    };
  }
};

export const getDrillDownInvoices = async (filters: DrillDownFilters) => {
  try {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.days_overdue_min !== undefined) params.append('days_overdue_min', filters.days_overdue_min.toString());
    if (filters.days_overdue_max !== undefined) params.append('days_overdue_max', filters.days_overdue_max.toString());
    if (filters.amount_min !== undefined) params.append('amount_min', filters.amount_min.toString());
    if (filters.amount_max !== undefined) params.append('amount_max', filters.amount_max.toString());
    if (filters.debtor_id) params.append('debtor_id', filters.debtor_id.toString());

    const queryString = params.toString();
    const endpoint = `/billing/invoices/drill-down/${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiClient.get(endpoint);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.detail || 'Error al obtener facturas filtradas',
    };
  }
};

export const markAlertAsRead = async (alertId: string) => {
  try {
    const response = await apiClient.patch(`/billing/dashboard/alerts/${alertId}/`, {
      is_read: true,
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error: error.response?.data?.detail || 'Error al marcar alerta como leída',
    };
  }
};
